<template>
  <el-dialog id="ff" title="添加学生" :visible.sync="visibleDialog" width="50%"  :before-close="closeEditDialog">
    <el-form ref="" label-position="left" label-width="80px" :rules="rules" :model="editFormData">

      <el-form-item label="姓名" prop="realname">
        <el-input clearable v-model="editFormData.realname" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="性别" prop="sex">
        <el-radio-group class="sex" style="margin-left: -75%;" v-model="editFormData.sex">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="学生状态">
          <el-select class="select" filterable  clearable v-model="editFormData.state" placeholder="请选择" style="width:100%;">
            <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
      </el-form-item>


      <el-form-item label="家庭住址" prop="regionName">
        <el-row>
          <el-col :span="4">
             <el-select v-model="regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;"  @change="handleClear">
               <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
             </el-select>
          </el-col>
          <el-col :span="20">
            <el-autocomplete
              style="width:100%;" 
              v-model="newaddress"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入上课地点，例如：小区楼号，大厦名称"
              clearable
              @clear="handleautocompleteClear"
              @select="handleSelect">
                <template slot-scope="{ item }">
                  <span style="float: left">{{ item.value }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.address }}</span>
                  <i style="float: right; margin-top: 10px;  margin-right: 5px;" class="el-icon-location-information"></i>
                </template>
            </el-autocomplete>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input v-model="detailedAddress" placeholder="请输入单元、楼层、门牌号"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="remarks" type="textarea"  :autosize="{ minRows: 3, maxRows: 3 }" placeholder="除详细地址外，需要同步给老师的信息"></el-input>
      </el-form-item>


      <el-form-item label="备用地址">
          <div style="width: 100%;text-align: start; display: flex; padding-top: 10px;">
            <div style="font-size: 20px;height: 20px; width: 20px;border: 1px solid #fff;" @click="handleAdd" class="el-icon-circle-plus-outline" ></div>
            <div style="font-size: 20px;height: 20px; width: 20px;border: 1px solid #fff;margin-left: 10px;" @click="handleRemove" class="el-icon-remove-outline" ></div>
          </div>
      </el-form-item>

      <el-form-item label="" v-if="ListDataLngLat.length > 0">
          <div v-for="(rowItme,rowIndex) in ListDataLngLat" :key="rowIndex" style="margin-bottom: 40px; margin-top: 10px;">
            <el-form-item label="家庭住址" prop="regionName" style="margin-bottom: 10px;">
              <el-row>
                <el-col :span="4">
                  <el-select v-model="rowItme.regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;"  @change="handleClears(rowItme,rowIndex)">
                    <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="20">
                  <el-autocomplete
                    style="width:100%;" 
                    v-model="rowItme.newaddress"
                    :fetch-suggestions="querySearchAsyncs"
                    placeholder="请输入上课地点，例如：小区楼号，大厦名称"
                    clearable
                    @clear="handleautocompleteClears(rowItme,rowIndex)"
                    @select="handleSelects(rowItme,$event)">
                      <template slot-scope="{ item }">
                        <span style="float: left">{{ item.value }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.address }}</span>
                        <i style="float: right; margin-top: 10px;  margin-right: 5px;" class="el-icon-location-information"></i>
                      </template>
                  </el-autocomplete>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="详细地址" style="margin-bottom: 10px;">
              <el-input v-model="rowItme.detailedAddress" placeholder="请输入单元、楼层、门牌号"></el-input>
            </el-form-item>
            <el-form-item label="备注" style="margin-bottom: 10px;">
              <el-input v-model="rowItme.remarks" type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" placeholder="除详细地址外，需要同步给老师的信息"></el-input>
            </el-form-item>
          </div>
      </el-form-item>



      

      <el-form-item label="微信">
        <el-input v-model="editFormData.wechat" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="年级" style="text-align: left;" prop="grades"> 
        <!-- <el-input v-model="editFormData.grade" autocomplete="off"></el-input> -->
        <el-cascader clearable style="width: 100%;" v-model="editFormData.grades" :options="gradeList"
          :props="props"></el-cascader>
      </el-form-item>
      <el-form-item label="家长电话">
        <el-input v-model="editFormData.telephone" maxlength="11" autocomplete="off"></el-input>
      </el-form-item>
      <!-- <el-form-item label="家庭住址">
        <el-input v-model="editFormData.address" autocomplete="off"></el-input>
      </el-form-item> -->

      <el-form-item label="销售" prop="saleId">
        <el-select class="select" filterable  clearable v-model="editFormData.saleId" placeholder="请选择销售" style="width:100%;"   :filter-method="handleChangeName">
          <el-option v-for="source in salesName" :key="source.saleId" :value="source.saleId" :label="source.label">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="跟进助理">
        <el-select class="select"  filterable  clearable v-model="editFormData.assistantId" placeholder="请选择跟进助理"
          style="width:100%;">
          <el-option v-for="source in Progressteacher" :key="source.id" :value="source.id" :label="source.realname">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="渠道" prop="channelType">
         <el-select clearable id="teacher" filterable   class="select" v-model="editFormData.channelType" style="width:100%;" placeholder="请选择渠道">
           <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
           </el-option>
         </el-select>
       </el-form-item>

       <el-form-item label="诊断师">
         <el-select class="select" filterable  clearable v-model="editFormData.diagnoseTeacherId" placeholder="请选择诊断师" style="width:100%;">
           <el-option v-for="item in Progressteacher1111" :key="item.teacherId" :value="item.teacherId" :label="item.teacherName">
           </el-option>
         </el-select>
       </el-form-item>
<!-- 
       <el-form-item label="规划师">
         <el-select class="select" filterable  clearable v-model="editFormData.projectTeacherId" placeholder="请选择规划师" style="width:100%;">
           <el-option v-for="item in Progressteacher2222" :key="item.teacherId" :value="item.teacherId" :label="item.teacherName">
           </el-option>
         </el-select>
       </el-form-item> -->


      <el-form-item label="来源">
        <!-- <el-select class="select" filterable  clearable allow-create default-first-option v-model="editFormData.sourcepeopleId"
          placeholder="请选择或输入来源负责人" style="width:100%;">
          <el-option v-for="source in sourcesPeople" :key="source.sourcepeopleId" :value="source.sourcepeopleId"
            :label="source.sourcepeopleName">
          </el-option>
        </el-select> -->
       <selectcomtent style="width:100%;" width="100%" :objUrl="{  tiile:'来源',  selectList:'/customerinformation/sourcelist', keys:'editFormData.sourcepeopleId', }" @handleChangeSelect="handleChangeSelect"></selectcomtent>
      </el-form-item>
      <el-form-item label="跟进老师">
        <el-select class="select" multiple filterable  clearable v-model="editFormData.progressTeacherIds" placeholder="请选择跟进老师"
          style="width:100%;">
          <el-option v-for="source in Progressteacher1" :key="source.id" :value="source.id" :label="source.realname">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学生类型" prop="classType">
        <el-select class="select" filterable  clearable v-model="editFormData.classType" placeholder="请选择" style="width:100%;">
          <el-option v-for="item in classTypes" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预存课时">
        <el-input-number style="display: flex;width: 100%;" v-model="prestoreHoursNum"  :min="0" :max="999" ></el-input-number>
      </el-form-item>
      <el-form-item label="消除课时">
        <el-input-number style="display: flex;width: 100%;" v-model="eliminateHoursNum"  :min="0" :max="999" ></el-input-number>
      </el-form-item>
      <el-form-item label="所欠课时">
        <el-input-number style="display: flex;width: 100%;" v-model="arrearsHoursNum"  :min="0" :max="999" ></el-input-number>
      </el-form-item>
      <!-- <el-form-item label="老师">
          <el-input
            placeholder="搜索老师"
            v-model="searchTeachers"
            @keyup.enter.native="handleSearch"
            clearable
          ></el-input>
        </el-form-item> -->
    </el-form>
    <!-- 老师列表 -->
    <!-- <el-table
        :header-cell-style="{
          background: '#fafafa'
        }"
        border
        :data="teacherData"
        :stripe="true"
        :highlight-current-row="true"
        @selection-change="handleSelectionChange"
      >
        <el-table-column label="序号" type="selection"></el-table-column>
        <el-table-column prop="realname" label="姓名" fixed></el-table-column>
        <el-table-column prop="age" label="年龄" fixed></el-table-column>
        <el-table-column prop="teach" label="学科" fixed></el-table-column>
        <el-table-column
          prop="telephone"
          label="电话"
          fixed
          width="120"
        ></el-table-column>
        <el-table-column prop="jobName" label="职级" fixed></el-table-column>
        <el-table-column prop="jobStatus" label="在职状态" fixed>
          <template slot-scope="scope">
            <span v-if="scope.row.jobStatus === 1">在职</span>
            <span v-else-if="scope.row.jobStatus === 2">离职</span>
          </template>
        </el-table-column>
      </el-table> -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="saveAdd()">保存 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import selectcomtent from "../selectcomtent.vue";

export default {
  components: { selectcomtent },
  data () {
    return {

      rules: {
        realname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        sex: [
          { required: true, message: "请选择性别", trigger: "change" }
        ],
        grades: [
          { required: true, message: "请选择年级", trigger: "change" }
        ],
        //saleId: [
        //  { required: true, message: "请选择销售", trigger: "change" }
        //],
        classType: [
          { required: true, message: "请选择学生类型", trigger: "change" }
        ],
        channelType: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        
      },
      prestoreHoursNum: 0,
      eliminateHoursNum: 0,
      arrearsHoursNum: 0,
      classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' }, { value: 4, label: '流失' }],
      classTypes: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
      gradeList: [],
      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },
      visibleDialog: false,
      editFormData: {
        channelType:'',
        diagnoseTeacherId:'',
        projectTeacherId:'',
        state:"",
        classType: "",
        id: "",
        studentNo: "",
        username: "",
        realname: "",
        grades: [],
        classNo: "",
        telephone: "",
        email: "",
        address: "",
        sex: "",
        wechat: "",
        sourcepeopleId: "",
        saleId: "",
        progressTeacherName: [],
        progressTeacherIds: [],
        createTime: null,
        assistantId:'',
      },
      regionName: 1,
      districtId: '',
      Progressteacher: [],
      Progressteacher1: [],
      teacherData: [],
      sourcesPeople: [],
      salesName: [],
      // classTypes_ss: [{id:'北京',name:'北京'},{id:'深圳',name:'深圳'}],
      optionsListt:[
        // {dictValue:"北京", dictType:1 },
        // {dictValue:"深圳", dictType:2 },
      ],
      optionsListtt:[],

      selseNames: 1,
      inputNames:'',


      newaddress:'',
      detailedAddress:'',
      remarks:'',

      searchResults: [],
      infoObj: {},

      ListDataLngLat:[],

      xxxxx: 0,
      DealTypeListt: [
        {
          value: 1,
          label: "线上",
        },
        {
          value: 2,
          label: "线下",
        },
        {
          value: 3,
          label: "转介绍",
        },
      
      ],

      Progressteacher1111:[],
      Progressteacher2222:[],

    };
  },
  created () {
    this.getDataSoursePeople();
    this.getTeacher();
    // this.teacherSale();
    this.getGrade()

    this.Progressteacher1111 = JSON.parse(sessionStorage.getItem('diagnoseTeacherFindList'))
    this.Progressteacher2222 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ 
       this.optionsListt = res.data.data
      
        axios.get(`${ apiBaseUrl }/dict/getDictionarySon/${this.regionName} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
            if(res.data.code === 200){
                this.optionsListtt = res.data.data
            }else{
              this.optionsListtt = []
            }
        }).catch((err)=>{
            // this.$message({ message: err , type: "error" })
        })
      })

    this.salesName = JSON.parse(sessionStorage.getItem('customersaleObj1'))
  },
  methods: {
    handleChangeSelect (keys,value) {
       this[keys] = value
    },

    handleChangeName(value) {
      if (value) {
        axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
            let datas = res.data.data.map(fore => {
                fore.id = fore.telephone
                fore.saleId = fore.saleId
                fore.label = fore.saleName 
                return fore
            })
            this.salesName = datas
          }else{
            this.salesName = JSON.parse(sessionStorage.getItem('customersaleObj1'))
          }
        })
      } else {
        this.salesName = JSON.parse(sessionStorage.getItem('customersaleObj1'))
      }
    },

    handleAdd(){
      this.ListDataLngLat.push({
          regionName:'',
          newaddress:'',
          detailedAddress:'',
          remarks:'',
          latitude:'',
          city:'',
          value: '',
          city: '',
          district: '',
          addressTitleName: '',
          addressFollow: '',
          districtName: '',
          address: '',
          precisionLng: '',
      })
    },

    handleRemove(){
       this.ListDataLngLat.pop()
    },

    handleeChangeinputNames(e){
      console.log(e)
    },

    handleClear(event) {
      console.log('Selected value:', event);
      this.remarks = ''
      this.detailedAddress = ''
      this.newaddress = ''
    },

    handleClears(item) {
      console.log('Selected value:', item);
      this.xxxxx = item.regionName
      item.remarks = ''
      item.detailedAddress = ''
      item.newaddress = ''
      item.precisionLng = ''
      item.city = ''
      item.latitude = ''
      item.latitude = ''
      item.precisionLng = ''
      item.city = ''
      item.remarks = ''
      item.detailedAddress = ''
      item.newaddress = ''
      item.precisionLng = ''
      item.city = ''
      item.latitude = ''
      item.value = ''
      item.district = ''
      item.addressTitleName = ''
      item.addressFollow = ''
      item.districtName = ''
      item.address = ''
      
    },


     // 模拟从后端获取搜索结果
    async querySearchAsyncs(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }

      // 模拟调用后端接口获取数据
      const results = await this.fetchAddressesFromBackends(queryString);

      // 调用回调函数，传递搜索结果
      cb(results);
    },

    // 模拟后端接口请求
    fetchAddressesFromBackends(query) {
       return new Promise((resolve, reject) => {
            let dateObj = {
              regionName: this.xxxxx === 1 ? '北京' : this.xxxxx === 2 ? '深圳' : this.xxxxx === 3 ? '上海' : this.xxxxx === 4 ? '广州' : '',
              keyword: query
            }
            axios.post(`${apiBaseUrl}/student/getSiteInfoList`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                console.log(res.data.data, '获取地址列表')
                resolve(res.data.data.map(item => ({
                      value: item.addressTitleName,
                      city: item.districtName,
                      district: item.addressFollow,
                      addressTitleName: item.addressTitleName,
                      addressFollow: item.addressFollow,
                      districtName: item.districtName,
                      address: item.addressFollow,
                      latitude: item.latitude,
                      precisionLng: item.precisionLng,
                })));
              } else {
                this.$message.error('检查网络，或选择所属地域~');
                resolve([]);
              }
            }).catch(err => {
              this.$message.error(err,'检查网络，请联系管理员~');
              reject(new Error('JSONP请求失败'));
            })
        })

    },


    // 模拟从后端获取搜索结果
    async querySearchAsync(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }

      // 模拟调用后端接口获取数据
      const results = await this.fetchAddressesFromBackend(queryString);

      // 调用回调函数，传递搜索结果
      cb(results);
    },

    // 模拟后端接口请求
    fetchAddressesFromBackend(query) {
       return new Promise((resolve, reject) => {
            let dateObj = {
              regionName: this.regionName === 1 ? '北京' : this.regionName === 2 ? '深圳' : this.regionName === 3 ? '上海' : this.regionName === 4 ? '广州' : '',
              keyword: query
            }
            axios.post(`${apiBaseUrl}/student/getSiteInfoList`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                console.log(res.data.data, '获取地址列表')
                resolve(res.data.data.map(item => ({
                      value: item.addressTitleName,
                      city: item.districtName,
                      district: item.addressFollow,
                      address: item.addressFollow,
                      latitude: item.latitude,
                      precisionLng: item.precisionLng,
                })));
              } else {
                resolve([]);
                this.$message.error(err);
              }
            }).catch(err => {
              this.$message.error(err);
              reject(new Error('JSONP请求失败'));
            })
        })


      // return new Promise((resolve, reject) => {
      //     const regionName = this.regionName === 1 ? '北京' : this.regionName === 2 ? '深圳' : this.regionName === 3 ? '上海' : this.regionName === 4 ? '广州' : '';
      //     const apiKey = 'V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD';
      //     const callbackName = `jsonpCallback_${Date.now()}`;
      //     const script = document.createElement('script');
      //     script.src = `https://apis.map.qq.com/ws/place/v1/suggestion?keyword=${encodeURIComponent(query)}&region=${regionName}&key=${apiKey}&output=jsonp&callback=${callbackName}`;

      //     window[callbackName] = (data) => {
      //         document.body.removeChild(script);
      //         delete window[callbackName];
      //         if (data.status === 0) {
      //             resolve(data.data.map(item => ({
      //                 value: item.title,
      //                 city: item.city,
      //                 district: item.district,
      //                 address: item.address,
      //                 location: item.location,

      //             })));
      //         } else {
      //             console.error('腾讯地图API错误:', data.message);
      //             resolve([]);
      //         }
      //     };

      //     script.onerror = () => {
      //         document.body.removeChild(script);
      //         delete window[callbackName];
      //         reject(new Error('JSONP请求失败'));
      //     };

      //     document.body.appendChild(script);
      // });
    },

    // 当用户选择一个建议时触发
    handleSelect(item) {
      console.log('用户选择了:', item);
      this.infoObj = item;
      this.newaddress = item.value; // 确保选中的值绑定到表单中
    },

    handleSelects(item,event) {
      console.log('用户选择了handleSelects:', item,event);
      item.latitude = event.latitude
      item.precisionLng = event.precisionLng
      item.city = event.city
      item.newaddress = event.value
      item.precisionLng = event.precisionLng 
      item.city = event.city
      item.latitude = event.latitude
      item.value = event.value
      item.district = event.district
      item.addressTitleName = event.addressTitleName
      item.addressFollow = event.addressFollow
      item.districtName = event.districtName
      item.address = event.address
    },

    handleautocompleteClear(event) {
      this.infoObj = {};
    },

    handleautocompleteClears(item,index) {
      console.log('handleautocompleteClears:', item,index);
      item.latitude = ''
      item.precisionLng = ''
      item.city = ''
    },

    //获取年级
    getGrade () {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    changeRegion(){
      axios.get(`${ apiBaseUrl }/dict/getDictionarySon/${this.regionName} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
          if(res.data.code === 200){
              this.optionsListtt = res.data.data
          }else{
            this.optionsListtt = []
          }
       }).catch((err)=>{
           this.$message({ message: err , type: "error" })
       })
    },
    //点击添加保存学生
    saveAdd () {

      console.log(this.ListDataLngLat, 'ListDataLngLat>>>>>>>>>>>>>>')

      if(!this.editFormData.channelType){
        this.$message({  message: '请选择渠道', type: 'warning'  });
        return;
      }

      const data = {
        realname: this.editFormData.realname,
        sex: this.editFormData.sex,
        telephone: this.editFormData.telephone,
        address: this.editFormData.address,
        grades: this.editFormData.grades,
        wechat: this.editFormData.wechat,
        sourcepeopleId: null,
        progressTeacherIds: this.editFormData.progressTeacherIds,
        saleId: this.editFormData.saleId,
        sourceName: "",
        classType: this.editFormData.classType,
        prestore: this.prestoreHoursNum,
        eliminate: this.eliminateHoursNum,
        arrears: this.arrearsHoursNum,
        assistantId:this.editFormData.assistantId,
        // regionName:this.regionName,
        districtId: this.districtId,


        regionName: this.regionName ? this.regionName : '',
        addressTitleName: this.infoObj.value ? this.infoObj.value : '',
        addressFollow: this.infoObj.address ? this.infoObj.address : '',
        addressInfo: this.detailedAddress ? this.detailedAddress : '',
        addressRemark: this.remarks ? this.remarks : '',
        districtName: this.infoObj.city ? this.infoObj.city : '',
        latitude: this.infoObj.latitude ? this.infoObj.latitude : '',
        precisionLng: this.infoObj.precisionLng ? this.infoObj.precisionLng : '',

        prepareAddressList: this.ListDataLngLat,

        diagnoseTeacherId:this.editFormData.diagnoseTeacherId,
        projectTeacherId:this.editFormData.projectTeacherId,
        channelType:this.editFormData.channelType,

      };

      if (typeof this.editFormData.sourcepeopleId === 'number') {
        data.sourcepeopleId = this.editFormData.sourcepeopleId
      } else {
        data.sourceName = this.editFormData.sourcepeopleId
      }
      
      if(!this.regionName){
        this.$message({
          message: '请选择所在地域',
          type: 'warning'
        });
        return;
      }
      if(!this.editFormData.realname){
        this.$message({
          message: '请输入姓名',
          type: 'warning'
        });
        return;
      }

      if(!this.editFormData.grades || this.editFormData.grades.length === 0){
        this.$message({
          message: '请选择年级',
          type: 'warning'
        });
        return;
      }

      if(!this.editFormData.sex){
        this.$message({
          message: '请选择性别',
          type: 'warning'
        });
        return;
      }

      if(!this.editFormData.classType){
        this.$message({
          message: '请选择班型',
          type: 'warning'
        });
        return;
      }

      // if(!this.editFormData.saleId){
      //   this.$message({
      //     message: '请选择销售',
      //     type: 'warning'
      //   });
      //   return;
      // }

      
      if(this.regionName && this.editFormData.realname && this.editFormData.grades && this.editFormData.sex && this.editFormData.classType){
        axios.post(`${apiBaseUrl}/student/addstudent`, data,{  headers:{  'authorization': sessionStorage.getItem('tokenInfo')  } }) .then(res => {
          // console.log(res, "pppppppppppp");
          if (res.data.code == 200) {
            //成功
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.ListDataLngLat = []
            this.visibleDialog = false;
            this.infoObj = {}
            this.remarks = ''
            this.detailedAddress = ''
            this.newaddress = ''  
            this.regionName = ''
            this.$emit("refresh");
          } else {
            //失败
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
      }else{
        this.$message({
          message: '请填写必填项',
          type: 'warning'
        });
      }
      
    },
    closeEditDialog () {
      this.ListDataLngLat = []
      this.visibleDialog = false;
      this.infoObj = {}
      this.remarks = ''
      this.detailedAddress = ''
      this.newaddress = ''  
      this.regionName = ''
      this.$emit("refresh");
    },
    init () {
      this.visibleDialog = true;
      this.editFormData = {};
      //点击按钮表单清空
      axios
        .post(`${apiBaseUrl}/teacher/query`, {
          page: "",
          limit: "",
          realname: this.searchTeachers
        },{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.teacherData = res.data.data.list;
        })
        .catch(err => {
          console.log(err);
        });
    },
    cancel () {
      this.visibleDialog = false;
      this.regionName = 1
    },
    //客资来源负责人
    getDataSoursePeople () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.sourcesPeople = response.data.data.list;
        })
        .catch(error => {
          console.error(error);
        });
    },
    //销售
    teacherSale () {
      axios
        .get(`${apiBaseUrl}/teacher/teacherSale`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.salesName = response.data.data
          // this.Progressteacher = response.data.data  //跟进老师
          // console.log(this.Progressteacher,"111");
          // console.log(response.data.data);
          // this.Progressteacher = response.data.data; //跟进老师
          // console.log(this.Progressteacher,"111");
          // console.log(response.data.data);
          // console.log(response,'hhhhhhgh')
        })
        .catch(error => {
          console.error(error);
        });
    },
    //跟进老师
    getTeacher () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          // this.salesName = response.data.data;
          this.Progressteacher1 = response.data.data; //跟进老师
          // console.log(this.Progressteacher,"111");
          // console.log(response.data.data);
          // console.log(response,'hhhhhhgh')
        })
        .catch(error => {
          console.error(error);
        });
      axios
        .get(`${apiBaseUrl}/schedule/assistantList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          // this.salesName = response.data.data;
          this.Progressteacher = response.data.data; //跟进老师
          // console.log(this.Progressteacher,"111");
          // console.log(response.data.data);
          // console.log(response,'hhhhhhgh')
        })
        .catch(error => {
          console.error(error);
        });
    },

    // 点击编辑学生回显数据
    editById (index, row) {
      let modifyId = row.id;
      this.$axios
        .get(`${apiBaseUrl}/student/` + modifyId,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.editFormData.id = res.data.data.id; //学生id
          this.editFormData.studentNo = res.data.data.studentNo;
          this.editFormData.username = res.data.data.username;
          this.editFormData.realname = res.data.data.realname;
          this.editFormData.grade = res.data.data.grade;
          this.editFormData.classNo = res.data.data.classNo;
          this.editFormData.telephone = res.data.data.telephone;
          this.editFormData.email = res.data.data.email;
          this.editFormData.address = res.data.data.address;
          this.editFormData.age = res.data.data.age;
          this.editFormData.sex = res.data.data.sex + "";
          this.editFormData.wechat = res.data.data.wechat;
          this.editFormData.sourcepeopleId = res.data.data.sourcepeopleId;
          this.editFormData.progressTeacherName =
            res.data.data.progressTeacherName;
          this.editFormData.progressTeacherIds =
            res.data.data.progressTeacherIds;
          // console.log(res.data.data.progressTeacherName);
          this.editFormData.saleId = res.data.data.saleId;
          this.regionName  = res.data.data.regionName ? res.data.data.regionName : 1;
          this.districtId = res.data.data.districtId ? res.data.data.districtId : '';

          this.xxxxx = Number(res.data.data.regionName)

          if (res.data.data.prepareAddress instanceof Array) {
               this.ListDataLngLat = res.data.data && res.data.data.prepareAddress.length > 0 ? res.data.data.prepareAddress : []
          }
          if (res.data.data.prepareAddress){
              this.ListDataLngLat = res.data.data && res.data.data.prepareAddress ? JSON.parse(res.data.data.prepareAddress).map((itmes)=>{
                  itmes.value = itmes.addressTitleName
                  itmes.city = itmes.districtName
                  itmes.district = itmes.addressFollow
                  itmes.addressTitleName = itmes.addressTitleName
                  itmes.addressFollow = itmes.addressFollow
                  itmes.districtName = itmes.districtName
                  itmes.address = itmes.addressFollow
                  itmes.latitude = itmes.latitude
                  itmes.precisionLng = itmes.precisionLng
                  itmes.regionName = Number(res.data.data.regionName)
                  itmes.detailedAddress = itmes.addressInfo 
                  itmes.remarks = itmes.addressRemark 
                  itmes.newaddress = itmes.addressTitleName

                  return itmes
              }) : []
          }


          console.log(this.ListDataLngLat,'this.ListDataLngLat')


        })
        .catch(error => { });
      this.editFormData = row;
      this.visibleForm = true;
    },

    //编辑提交
    commit () {
      // console.log(this.editFormData.progressTeacherIds);
      this.editFormData.sex = this.editFormData.sex;
      this.modifyStudent(this.editFormData);
    },

    //更新学生
    modifyStudent (modifyData) {
      modifyData.createTime = null;

      this.$axios
        .post(
          `${apiBaseUrl}/student/modify/` + this.editFormData.id,
          modifyData
          ,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(JSON.stringify(modifyData));
          this.$message({ message: "更新成功", type: "success" });
          this.allStudent();
          this.visibleForm = false;
        })
        .catch(error => {
          this.$message.error("更新失败");
        });
    }
  }
};
</script>

<style scoped lang="less">

 /deep/ .el-input-group__prepend{
  width: 40px;
}
/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */

  // #ff>>>.el-dialog {
  //   width: 70% !important;
  // }
}
</style>



// WEBPACK FOOTER //
// src/manager/components/EditStudents.vue